// extracted by css-extract-rspack-plugin
module.exports =  {"navigator":"Navigator__navigator--kufFG","header":"Navigator__header--pTf4z","body":"Navigator__body--gbtA5","item":"Navigator__item--j2ntq"};